<template>
  <v-select
    :value="value"
    :items="documentTypes"
    label="Select Document Type"
    item-text="label"
    item-value="id"
    :rules="[validateRequired]"
    dense
    @change="onChange"
  />
</template>

<script>
import { validateRequired } from '@/utils/validationRules'
import { listAllDocumentTypes } from '../dataAccess/documentTypes'

export default {
  name: 'DocumentTypeSelect',
  props: {
    value: { type: String, default: 'assetSale' }
  },
  data() {
    return {
      documentTypes: listAllDocumentTypes()
    }
  },
  methods: {
    validateRequired,
    onChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>
